import { rootStateBranchSelector } from '../../utils/rootStateBranchSelector';

export const offerDataSelector = rootStateBranchSelector('offerData');
